import { API } from 'aws-amplify';

// eslint-disable-next-line no-unused-vars
function init(arg0: string, arg1: string, _init: any, any: any)
{
	throw new Error('Function not implemented.');
}

export function getConnectionSuggestionData(queryStringParameters)
{
	return API.get('connectionManagement', '/getConnectionSuggestion', { queryStringParameters });
}
export function getFollowData(queryStringParameters:any)
{
	return API.get('connectionManagement', '/getFollowRelationList', { queryStringParameters });
}
export function getBlockData(queryStringParameters:any)
{
	return API.get('connectionManagement', '/getBlockCompanyList', { queryStringParameters });
}
export function getConnections(queryStringParameters:any)
{
	return API.get('connectionManagement', '/getConnections', { queryStringParameters });
}
export function createBadgeCount(queryStringParameters:any)
{
	return API.post('connectionManagement', '/badgecount', { queryStringParameters });
}
export function getSuggestion(queryStringParameters:any)
{
	return API.get('connectionManagement', '/getConnectionSuggestion', { queryStringParameters });
}
export function getConnectionRelationData(queryStringParameters:any)
{
	return API.get('departments', '/getRelations', { queryStringParameters });
}
export function getRelations(queryStringParameters:any)
{
	return API.get('departments', '/relations', { queryStringParameters });
}
export function getConnectionCount(queryStringParameters:any)
{
	return API.get('connectionManagement', '/getConnectionCount', { queryStringParameters });
}
export function getRelationManagers(queryStringParameters)
{
	return API.get('connectionManagement', '/getRelationManagersList', { queryStringParameters });
}
export function initiateContract(body)
{
	return API.post('connectionManagement', '/contract', { body });
}

export function updateInitiatedContract(body)
{
	return API.put('connectionManagement', '/contract', { body });
}

//
export function getBlockRequest(body:any, queryStringParameters:any)
{
	return API.post('connectionManagement', '/blockOrUnblockUser', { queryStringParameters, body });
}
export function getNetwork(query:string)
{
	return API.get('connectionManagement', `/getConnections${query}`, init);
}
export function getSuggestionsData(query:any)
{
	return API.get('userManagement', `/suggestions${query}`, init);
}
export function RequestFollow(body:any)
{
	return API.post('connectionManagement', '/followRelation', { body });
}
export function Connect(body:any)
{
	return API.post('connectionManagement', '/createConnection', { body });
}
export function getPendingConnections(query:any)
{
	return API.get('connectionManagement', `/getConnections${query}`, init);
}

export function getApprovedConnections(query:any)
{
	return API.get('connectionManagement', `/getConnections${query}`, init);
}

export function ConnectionRequest(body:any)
{
	return API.put('connectionManagement', '/approveReject', { body });
}
export function CompanyFollowList(query:string)
{
	return API.get('connectionManagement', `/getFollowListByCompany${query}`, init);
}
export function UpdateRelationConnection(body:any)
{
	return API.put('connectionManagement', '/connection', { body });
}

export function DeleteNetworkConnection(queryStringParameters:any)
{
	return API.del('connectionManagement', '/connection', { queryStringParameters });
}

// export function shareWithCompaniesEmp(query:any)
// {
// 	return API.get('connectionManagement', `/shareWith${query}`, init);
// }

export function getProducts(query:any)
{
	return API.get('connectionManagement', `/product${query}`, init);
}
// query = {id:'dealId'}

export function getDealById(query:any)
{
	return API.get('connectionManagement', `/deal${query}`, init);
}
// query = {createdBy(me or others), type(approved,reject, pending,expired), search ,limit, skip}

export function getDealCompList(query:any)
{
	return API.get('connectionManagement', `/getDealCompList${query}`, init);
}
// path = {id:'companyId'}
// query = {createdBy(me or others),search ,limit, skip}

export function getDealsBycompanyId(path:any, query:any)
{
	return API.get('connectionManagement', `/getDealsBycompanyId/${path}${query}`, init);
}
export function getDealsByManagers(query:any)
{
	return API.get('connectionManagement', `/getDealManagers${query}`, init);
}
export function updateDealStatus(body:any)
{
	return API.put('connectionManagement', '/deal', { body });
}
// _id, status, extend

export function updateCustomProd(body:any)
{
	return API.put('connectionManagement', '/updatecustomproduct', { body });
}

export function createDeal(body:any)
{
	return API.post('connectionManagement', '/deal', { body });
}
export function createProduct(body:any)
{
	return API.post('connectionManagement', '/product', { body });
}
export function EditProduct(body:any)
{
	return API.put('connectionManagement', '/product', { body });
}
export function getProductList(query:any)
{
	return API.get('connectionManagement', `/product${query}`, init);
}
export function getRelationFilter(query:any)
{
	return API.get('connectionManagement', `/relationFilter${query}`, init);
}
export function getConnectedRelationsData(query:any)
{
	return API.get('departments', `/getConnectedRelations${query}`, init);
}

export function getConnectionswithRelationId(queryStringParameters:any)
{
	return API.get('folderManagement', '/getConnections', { queryStringParameters });
}